import { useCallback, useState } from "react";
import { toast } from "react-toastify";

function useAsyncFn<T extends any[], V>(fn: (...args: T) => Promise<V>) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<V | null>(null);
  const [error, setError] = useState<string | null>(null);

  const exec = useCallback(
    async (...args: T) => {
      setLoading(true);
      try {
        const data = await fn(...args);
        setData(data);
      } catch (e: any) {
        const errorMessage = e?.response?.data?.message || e?.message || "Request failed.";
        toast.error(errorMessage);
        // console.error(error);
        setError(errorMessage);
        setData(null);
        console.log("throwinggg");
        throw new Error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
    [fn],
  );

  return { exec, loading, data, error };
}

export default useAsyncFn;
